import React, { useEffect, useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";
import init from "../../firebase";
import { useUserAuth } from "../../context/UserAuthContext";

const Badge = () => {
  const { user } = useUserAuth();
  const merchant_id = user.uid;
  const [data, setData] = useState({});
  const subcription_id = "0HiF6hiHf6vcK1rstyuV";
  const getSubscriptions = async () => {
    try {
      const mycollection = doc(init.db, "configuration", subcription_id);
      const data = await getDoc(mycollection);
      setData(data.data());
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };
  console.log("my subscription data", data);
  useEffect(() => {
    getSubscriptions();
  }, [subcription_id]);
  const [badgeData, setBadgeData] = useState();
  console.log("my badge", badgeData);
  const badgeHandler = (e) => {
    const userChoice = e.target.value;
    if (userChoice == "verified") {
      setBadgeData((pre) => ({
        ...pre,
        type: userChoice,
        amount: "2100",
        tax: "378",
      }));
    } else if (userChoice == "top in town") {
      setBadgeData((pre) => ({
        ...pre,
        type: userChoice,
        amount: "4999",
        tax: "899",
      }));
    }
  };
  const totalAmount = Number(badgeData?.amount) + Number(badgeData?.tax);

  const paymentHistory = async () => {
    try {
      const docRef = await addDoc(collection(init.db, "paymentHistory"), {
        merchant_id,
        totalAmount,
        badgeType: badgeData?.type,
        badgePrice: badgeData?.amount,
        badgeTax: badgeData?.tax,
        createdAt: serverTimestamp(),
      });
    } catch (err) {
      console.log("payment history creation error", err);
    }
  };
  const btnHandler = async () => {
    let orderId = uuidv4();
    let paymentReq = {
      order_id: orderId,
      amount: totalAmount,
      currency: "INR",
      payment_capture: 1,
    };
    try {
      let result = await axios.post(
        "https://eventplanet.cyclic.cloud/create",
        paymentReq,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (!result.data.data) {
        alert("Something went wrong");
        return;
      } else {
        var options = {
          key: "rzp_test_N3UkCtGILm1iGD",
          amount: result.data.data.amount,
          currency: result.data.data.currency,
          name: "Event Planet",
          description: "Acchi Wali Feeling",
          image: "https://eventplanet.in/assets/home/logo_main.png",
          order_id: result.data.data.id,
          handler: function (response) {
            alert("Payment successful");
            paymentHistory();
          },

          prefill: {
            name: "Test User",
            email: "test@gmail.com",
            contact: "1234567890",
          },
          notes: {
            address: "",
          },
          theme: {
            color: "#3399cc",
          },
        };
        let paymentObj = new window.Razorpay(options);
        paymentObj.open();
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <form>
                  <div className="form-group col-md-4">
                    <select
                      name="badge"
                      onChange={badgeHandler}
                      className="form-select"
                    >
                      <option disabled selected>
                        Select Badge
                      </option>
                      <option value="verified">Verified</option>
                      <option value="top in town">Top In Town</option>
                    </select>
                  </div>
                </form>
                {badgeData && (
                  <div className="table-responsive ">
                    <table className="table table-bordered text-center table-hover  padding-bottom: 10px">
                      <thead>
                        <tr className="" style={{ backgroundColor: "#085f9a" }}>
                          <th className="text-white">Badge Type</th>
                          <th className="text-white">Amount</th>
                          <th className="text-white">Tax</th>
                          <th className="text-white">Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{badgeData?.type}</td>
                          <td>{badgeData?.amount}</td>
                          <td>{badgeData?.tax}</td>
                          <td>{totalAmount}</td>
                        </tr>
                      </tbody>
                    </table>
                    <center>
                      <button
                        className="btn btn-md  text-white"
                        style={{ backgroundColor: "#085f9a" }}
                        onClick={btnHandler}
                      >
                        Pay Now
                      </button>
                    </center>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Badge;
